import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/home/pages/home-page/home-page.component').then((m) => m.HomePageComponent),
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/forgot-password-page/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    path: 'forgot-password-otp',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/forgot-password-otp-page/forgot-password-otp-page.component').then(
        (m) => m.ForgotPasswordOtpPageComponent,
      ),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/pages/dashboard-page/dashboard-page.component').then(
        (m) => m.DashboardPageComponent,
      ),
  },
  {
    path: 'reservations',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reserve/pages/reserve-dashboard-page/reserve-dashboard-page.component').then(
        (m) => m.ReserveDashboardPageComponent,
      ),
  },
  {
    path: 'reservations/history',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reserve/pages/reserve-history-page/reserve-history-page.component').then(
        (m) => m.ReserveHistoryPageComponent,
      ),
  },
  {
    path: 'reservations/report',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reserve/pages/reserve-report-page/reserve-report-page.component').then(
        (m) => m.ReserveReportPageComponent,
      ),
  },
  {
    path: 'reservations/alerts',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reserve/pages/reserve-alerts-page/reserve-alerts-page.component').then(
        (m) => m.ReserveAlertsPageComponent,
      ),
  },
  {
    path: 'reservations/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/reserve/pages/reserve-detail-page/reserve-detail-page.component').then(
        (m) => m.ReserveDetailPageComponent,
      ),
  },
  {
    path: 'more',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/more/pages/more-page/more-page.component').then(
        (m) => m.MorePageComponent,
      ),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/notifications/pages/notifications-page/notifications-page.component').then(
        (m) => m.NotificationsPageComponent,
      ),
  },
  {
    path: 'notifications/broadcast',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './features/notifications/pages/notifications-broadcast-page/notifications-broadcast-page.component'
      ).then((m) => m.NotificationsBroadcastPageComponent),
  },
  {
    path: 'notifications/settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './features/notifications/pages/notifications-settings-page/notifications-settings-page.component'
      ).then((m) => m.NotificationsSettingsPageComponent),
  },
  {
    path: 'clients',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/clients/pages/clients-page/clients-page.component').then(
        (m) => m.ClientsPageComponent,
      ),
  },
  {
    path: 'clients/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/clients/pages/client-detail-page/client-detail-page.component').then(
        (m) => m.ClientDetailPageComponent,
      ),
  },
  {
    path: 'vehicles',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/pages/vehicles-page/vehicles-page.component').then(
        (m) => m.VehiclesPageComponent,
      ),
  },
  {
    path: 'car-inspection',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/inspection/pages/car-inspection-test-page/car-inspection-test-page.component').then(
        (m) => m.CarInspectionTestPageComponent,
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'step-1',
      },
      {
        path: 'step-1',
        loadComponent: () =>
          import(
            './features/inspection/pages/car-inspection-step-1-page/car-inspection-step-1-page.component'
          ).then((m) => m.CarInspectionStep1PageComponent),
      },
      {
        path: 'step-2',
        loadComponent: () =>
          import(
            './features/inspection/pages/car-inspection-step-2-page/car-inspection-step-2-page.component'
          ).then((m) => m.CarInspectionStep2PageComponent),
      },
    ],
  },
  {
    path: 'vehicles/register',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/pages/vehicle-register-page/vehicle-register-page.component').then(
        (m) => m.VehicleRegisterPageComponent,
      ),
  },
  {
    path: 'vehicles/register/wizard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/components/vehicle-wizard/vehicle-wizard.component').then(
        (m) => m.VehicleWizardComponent,
      ),
  },
  {
    path: 'vehicles/validator',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/pages/vehicle-validator-page/vehicle-validator-page.component').then(
        (m) => m.VehicleValidatorPageComponent,
      ),
  },
  {
    path: 'check-in/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/pages/vehicle-check-in-page/vehicle-check-in-page.component').then(
        (m) => m.VehicleCheckInPageComponent,
      ),
  },
  {
    path: 'check-out/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/pages/vehicle-check-out-page/vehicle-check-out-page.component').then(
        (m) => m.VehicleCheckOutPageComponent,
      ),
  },
  {
    path: 'vehicles/:id/services',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'service-record', action: 'show' } },
    loadComponent: () =>
      import('./features/vehicles/pages/vehicle-services-page/vehicle-services-page.component').then(
        (m) => m.VehicleServicesPageComponent,
      ),
  },
  {
    path: 'vehicles/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/vehicles/pages/vehicle-detail-page/vehicle-detail-page.component').then(
        (m) => m.VehicleDetailPageComponent,
      ),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/admin/pages/admin-panel-page/admin-panel-page.component').then(
        (m) => m.AdminPanelPageComponent,
      ),
  },
  {
    path: 'admin/companies',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'company', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/companies-page/companies-page.component').then(
        (m) => m.CompaniesPageComponent,
      ),
  },
  {
    path: 'admin/facilities',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'facility', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/facilities-page/facilities-page.component').then(
        (m) => m.FacilitiesPageComponent,
      ),
  },
  {
    path: 'admin/roles',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'roles', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/roles-page.component').then((m) => m.RolesPageComponent),
  },
  {
    path: 'admin/services',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'services', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/services-page/services-page.component').then(
        (m) => m.ServicesPageComponent,
      ),
  },
  {
    path: 'admin/users',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'users', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/users-page/users-page.component').then(
        (m) => m.UsersPageComponent,
      ),
  },
  {
    path: 'admin/users/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/admin/pages/user-detail-page/user-detail-page.component').then(
        (m) => m.UserDetailPageComponent,
      ),
  },
  {
    path: 'admin/permissions',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'permissions', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/permissions-page/permissions-page.component').then(
        (m) => m.PermissionsPageComponent,
      ),
  },
  {
    path: 'admin/audit',
    canActivate: [authGuard, permissionGuard],
    data: { permission: { module: 'audit', action: 'show' } },
    loadComponent: () =>
      import('./features/admin/pages/audit-page').then(
        (m) => m.AuditPageComponent,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
